import { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { ReceiptText } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CancellationPage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/pages/refund-cancellation`)
      .then(r => r.json())
      .then(data => setContent(data.content || ''))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="cancellation-page">
      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-slate-900 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(239,68,68,0.08),transparent_60%)]" />
        <div className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-red-500/10 rounded-lg flex items-center justify-center">
                <ReceiptText className="w-5 h-5 text-red-400" />
              </div>
              <span className="text-red-400 font-medium text-sm tracking-wide uppercase">Legal</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-heading font-bold text-white mb-4">Refund & Cancellation Policy</h1>
            <p className="text-white/60 text-lg">DNO Events & DMC Private Limited</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            {loading ? (
              <div className="flex justify-center py-20">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500" />
              </div>
            ) : (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="prose prose-slate prose-lg max-w-none
                  prose-headings:font-heading prose-headings:text-slate-900 prose-headings:font-bold
                  prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-4 prose-h2:border-b prose-h2:border-slate-100 prose-h2:pb-3
                  prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-3
                  prose-p:text-slate-600 prose-p:leading-relaxed
                  prose-li:text-slate-600
                  prose-strong:text-slate-800
                  prose-ul:list-disc prose-ul:pl-6 prose-ul:space-y-1
                  prose-a:text-red-600 prose-a:no-underline hover:prose-a:underline"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
              />
            )}

            <div className="mt-16 pt-8 border-t border-slate-100 flex flex-wrap gap-4 text-sm text-slate-400">
              <Link to="/privacy" className="hover:text-red-500 transition-colors">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms" className="hover:text-red-500 transition-colors">Terms & Conditions</Link>
              <span>|</span>
              <Link to="/contact" className="hover:text-red-500 transition-colors">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CancellationPage;
